module.exports = __webpack_public_path__ + "static/camposilvano_map-e4c1252860c1bcc78a9de1475ce3fec3.svg";